module.exports = __webpack_public_path__ + "static/media/shared-post-icon.d854aa39.svg";